const setSecondChildrenPassportNo = (data = null) => {
  return {
    type: 'SET_SECONDCHILDRENPASSPORTNO',
    data
  }
}

export default {
  setSecondChildrenPassportNo,
}
